import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

// PATH A: Content Optimization (existing content)
export function runContentOptimization(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_content_optimization`)
}

export function getContentOptimization(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/content_optimization`)
}

export function confirmContentImport(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/confirm_content_import`)
}

export function optimizeSection(pageId, sectionIndex) {
  return axios.post(`/ajax/website_pages/${pageId}/optimize_section`, { section_index: sectionIndex })
}

export function approveSection(pageId, contentChangeId, finalText = null) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_section`, {
    content_change_id: contentChangeId,
    final_text: finalText
  })
}

export function rejectSection(pageId, contentChangeId, notes) {
  return axios.post(`/ajax/website_pages/${pageId}/reject_section`, {
    content_change_id: contentChangeId,
    notes
  })
}

// PATH B: Content Creation (new content)
export function runContentCreation(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_content_creation`)
}

export function approveOutline(pageId, outlineEdits = null) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_outline`, {
    outline_edits: outlineEdits
  })
}

export function writeSection(pageId, sectionIndex) {
  return axios.post(`/ajax/website_pages/${pageId}/write_section`, { section_index: sectionIndex })
}

export function assembleArticle(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/assemble_article`)
}
